import { FormBuilder } from '@piying/view-core';
import type { SolidSchemaHandle } from './schema-handle';

export class SolidFormBuilder extends FormBuilder<SolidSchemaHandle> {}
